import React from "react";
import Section from "./Section";
import SectionHeading from "./SectionHeading";

const STEPS = [
  {
    title: "Install on GitHub",
    body: "Pick your org and repos on GitHub's own install screen. No webhook setup, nothing to configure by hand.",
  },
  {
    title: "Open a PR",
    body: "Business as usual — Anthurium watches for pull_request events on whatever you connected.",
  },
  {
    // "assigned on GitHub" is now literally true, not a convenient shorthand:
    // routing fires a real requested_reviewers call, so the reviewer gets
    // GitHub's own notification and the PR appears in their
    // review-requested:@me filter. Saying it plainly is the point — this was
    // the product's weakest claim for as long as the assignment existed only
    // in our own database.
    title: "Scored, prioritised, routed",
    body: "Complexity scored 0–10, review time estimated, and the right reviewer assigned on GitHub — before anyone opens the diff.",
  },
];

export default function HowItWorksSection() {
  return (
    <Section id="how-it-works" variant="elevated">
      <SectionHeading eyebrow="How it works" title="From install to routed in one webhook" />

      <div className="relative mt-16 grid gap-10 md:grid-cols-3 md:gap-6">
        <div className="pointer-events-none absolute left-[16.66%] right-[16.66%] top-6 hidden h-px bg-white/10 md:block" />

        {STEPS.map((step, i) => (
          <div
            key={step.title}
            className="relative flex flex-col items-start gap-4 md:items-center md:text-center"
          >
            <div className="relative z-10 flex h-12 w-12 shrink-0 items-center justify-center rounded-full border border-rf-border bg-rf-bg-secondary font-mono text-lg font-bold text-rf-accent">
              {i + 1}
            </div>
            <div>
              <h3 className="mb-1 text-lg font-semibold text-rf-text-primary">{step.title}</h3>
              <p className="text-sm leading-relaxed text-rf-text-secondary md:mx-auto md:max-w-[26ch]">
                {step.body}
              </p>
            </div>
          </div>
        ))}
      </div>
    </Section>
  );
}
